import { MAX_WIDGET_CARDS } from "@/shared/components/widgets/widget.constants";
import { useGetSchematicsByProductQuery } from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed, type Ref } from "vue";

export function useRelatedSchematics(productId: Ref<string | undefined>) {
    const { result, loading } = useGetSchematicsByProductQuery(
        () => ({ productId: productId.value }),
        () => ({ enabled: !!productId.value })
    );

    const allSchematics = computed(() => result.value?.schematics ?? []);

    const schematics = computed(() => allSchematics.value.slice(0, MAX_WIDGET_CARDS)); // Widget shows max 6 cards (See: QIT-7058 for "View all" page)
    const total = computed(() => allSchematics.value.length);

    return { schematics, total, loading };
}
